import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import appicon from '../../assets/appIcon.png';

const ChefVideoModal = ({ chef, onClose }) => {
  const videoRef = useRef(null);
  
  useEffect(() => {
    // Запускаем видео после небольшой задержки
    const timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(err => console.error('Fullscreen video playback error:', err));
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <motion.div 
      className="fullscreen-video-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(10px)'
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 100, damping: 15 }}
        style={{ width: '90%', maxWidth: '1200px', position: 'relative' }}
      >
        <video 
          ref={videoRef}
          src={chef.video}
          className="fullscreen-video"
          muted 
          playsInline
          loop
          preload="metadata"
          style={{ 
            width: '100%', 
            height: 'auto', 
            maxHeight: '80vh', 
            objectFit: 'cover',
            borderRadius: '20px',
            boxShadow: '0 10px 50px rgba(0, 0, 0, 0.5)'
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <motion.div 
          className="chef-info-overlay"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          style={{
            position: 'absolute',
            bottom: '50px',
            left: 0,
            right: 0,
            color: 'white',
            textShadow: '0 2px 10px rgba(0, 0, 0, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '0 20px'
          }}
        >
          <motion.div
            style={{
              position: 'absolute',
              top: 0, 
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)',
              zIndex: -1
            }}
          />
          
          <motion.h2 
            style={{ 
              fontSize: '82px', 
              fontWeight: 'bold',
              margin: '0 0 15px 0',
              letterSpacing: '2px',
              textShadow: '0 0 30px rgba(0, 0, 0, 1), 0 5px 15px rgba(0, 0, 0, 1), 0 2px 5px rgba(0, 0, 0, 1)',
              fontFamily: "'Montserrat', sans-serif",
              position: 'relative',
              display: 'inline-block',
              zIndex: 10
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              type: "spring", 
              stiffness: 100, 
              damping: 10,
              delay: 0.4 
            }}
          >
            {chef.name}
            <motion.div 
              style={{
                position: 'absolute',
                left: '0',
                bottom: '-5px',
                height: '4px',
                width: '0%',
                background: 'linear-gradient(90deg, rgba(255,255,255,1), rgba(255,255,255,0.3))'
              }}
              animate={{ width: '100%' }}
              transition={{ duration: 0.8, delay: 0.6 }}
            />
          </motion.h2>
          
          <motion.h3 
            style={{ 
              fontSize: '26px', 
              margin: '0 0 40px 0',
              fontWeight: '600',
              letterSpacing: '4px',
              textTransform: 'uppercase',
              color: '#ffffff',
              textShadow: '0 2px 8px rgba(0, 0, 0, 1), 0 1px 3px rgba(0, 0, 0, 1)',
              opacity: 1,
              background: 'rgba(0, 0, 0, 0.5)',
              padding: '8px 20px',
              borderRadius: '30px'
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            MASTER CHEF
          </motion.h3>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
            }}
            transition={{ 
              type: "spring", 
              stiffness: 300, 
              damping: 15, 
              delay: 0.7 
            }}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              maxWidth: '320px',
              margin: '0 auto'
            }}
          >
            <motion.a
              href="https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693"
              target="_blank"
              rel="noopener noreferrer"
              className="download-button-overlay"
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 0 25px rgba(255, 255, 255, 0.5)"
              }}
              whileTap={{ scale: 0.95 }}
              animate={{
                boxShadow: ["0 0 15px rgba(0, 0, 0, 0.5)", "0 0 25px rgba(0, 0, 0, 0.8)", "0 0 15px rgba(0, 0, 0, 0.5)"],
              }}
              transition={{
                boxShadow: {
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }
              }}
              onClick={(e) => e.stopPropagation()}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                color: '#ffffff',
                padding: '16px 32px',
                borderRadius: '50px',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: '18px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.7)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '320px'
              }}
            >
              <motion.div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
                  zIndex: 0
                }}
                animate={{
                  x: ['100%', '-100%']
                }}
                transition={{
                  x: {
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                    repeatDelay: 0.5
                  }
                }}
              />
              
              <div 
                className="apple-icon-overlay"
                style={{
                  marginRight: '15px',
                  width: '36px',
                  height: '36px',
                  borderRadius: '12%',
                  backgroundImage: `url(${appicon})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  zIndex: 1,
                  filter: 'brightness(1.5)'
                }}
              ></div>
              <span style={{
                zIndex: 1,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                fontWeight: 'bold'
              }}>
                Download  
              </span>
            </motion.a>
          </motion.div>
        </motion.div>
        <motion.button
          className="close-fullscreen-button"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            fontSize: '20px',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          ✕
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default ChefVideoModal; 